// Variant values are also used for class names
export enum IconVariant {
  Default = 'default',
  Blue = 'blue',
  Green = 'green',
  Grey = 'grey',
  Red = 'red',
  Yellow = 'yellow',
  AccordionToggleIcon = 'accordionToggleIcon',
  TableSortActive = 'tableSortActive',
  TableSortInactive = 'tableSortInactive',
}

export enum IconName {
  Add = 'add',
  AddNotes = 'addNotes',
  Alert = 'alert',
  Archive = 'archive',
  ArrowDown = 'arrowDown',
  ArrowLeft = 'arrowLeft',
  ArrowRight = 'arrowRight',
  ArrowUp = 'arrowUp',
  ArrowUpNOut = 'arrowUpNOut',
  Attach = 'attach',
  Awarded = 'awarded',
  Bin = 'bin',
  Calendar = 'calendar',
  Chat = 'chat',
  Check = 'check',
  ChevronDown = 'chevronDown',
  ChevronLeft = 'chevronLeft',
  ChevronUp = 'chevronUp',
  ChevronRight = 'chevronRight',
  Clear = 'clear',
  Close = 'close',
  Crane = 'crane',
  Dashboard = 'dashboard',
  Decrease = 'decrease',
  Documents = 'documents',
  Download = 'download',
  Edit = 'edit',
  EditAddFile = 'editAddFile',
  File = 'file',
  Flag = 'flag',
  FlagSolid = 'flagSolid',
  Folder = 'folder',
  FolderOpen = 'folderOpen',
  Fullscreen = 'fullscreen',
  GridMatrix = 'gridMatrix',
  Handover = 'handover',
  Help = 'help',
  Hourglass = 'hourglass',
  Increase = 'increase',
  Info = 'info',
  Location = 'location',
  Locked = 'locked',
  Magic = 'magic',
  Merge = 'merge',
  More = 'more',
  NotInterested = 'notInterested',
  Notes = 'notes',
  Notifications = 'notifications',
  NotificationsSolid = 'notificationsSolid',
  Packages = 'packages',
  Pdf = 'pdf',
  Print = 'print',
  Quoted = 'quoted',
  Quoting = 'quoting',
  Redo = 'redo',
  Reorder = 'reorder',
  Replace = 'replace',
  RulerPencil = 'rulerPencil',
  Search = 'search',
  SearchContent = 'searchContent',
  Send = 'send',
  Settings = 'settings',
  Star = 'star',
  StarSolid = 'starSolid',
  ToolHand = 'toolHand',
  Tools = 'tools',
  Undo = 'undo',
  Unlocked = 'unlocked',
  Update = 'update',
  Upload = 'upload',
  User = 'user',
  UserAdd = 'userAdd',
  UserDelete = 'userDelete',
  UserEdit = 'userEdit',
  UserRemove = 'userRemove',
  View = 'view',
}
